export const getToken = () => localStorage.getItem('@kavod:token')
